import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { contentSections } from "@/mocks/home";

export default function ContentBoard() {
  const [lead, ...rest] = contentSections;

  return (
    <section id="sections" className="border-y border-background-200 bg-background-100/50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="内容板块"
            title="黑料平台内容板块，按兴趣分区浏览"
            description="板块按领域划分，每个板块下再按话题聚合。想找什么直接从对应板块进，省去在信息流里翻找的时间。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <Reveal>
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative h-64 w-full overflow-hidden md:h-80">
                <img
                  src={lead.image}
                  alt={`${lead.name}板块配图`}
                  title={`${lead.name} - 黑料平台内容板块`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  {lead.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-xl font-bold text-foreground-950">
                  {lead.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{lead.desc}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-discuss-line" />
                    {lead.count}
                  </span>
                  <span className="inline-flex items-center gap-1 font-medium text-primary-600">
                    进入板块
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {rest.map((section, index) => (
              <Reveal key={section.name} delay={(index + 1) * 70}>
                <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <div className="relative h-32 w-full overflow-hidden">
                    <img
                      src={section.image}
                      alt={`${section.name}板块配图`}
                      title={`${section.name} - 黑料平台内容板块`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700">
                      {section.tag}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-4">
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {section.name}
                    </h3>
                    <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {section.desc}
                    </p>
                    <span className="mt-4 inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-discuss-line" />
                      {section.count}
                    </span>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}